<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="6" sm="3" md="3" class="py-0 my-0">
              <v-dialog
                ref="dialogFecha"
                v-model="modalFechaInicial"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    type="date"
                    readonly
                    dense
                    ref="fechaInicial"
                    v-model="fechaInicial"
                    :rules="[$rules.requerido]"
                    @click="modalFecha = true"
                    :error-messages="errorMessages"
                    :label="'Fecha Inicial'"
                    v-bind="attrs"
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaInicial" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="cancelFechaInicial">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="setFechaInicial(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="6" sm="3" md="3" class="py-0 my-0">
              <v-dialog
                ref="dialogFecha"
                v-model="modalFechaFinal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    type="date"
                    readonly
                    dense
                    ref="fechaFinal"
                    v-model="fechaFinal"
                    :rules="[$rules.requerido]"
                    @click="modalFechaFinal = true"
                    :error-messages="errorMessages"
                    :label="'Fecha Final'"
                    v-bind="attrs"
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaFinal" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="cancelFechaFinal">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="setFechaFinal(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="6" sm="3" md="3" class="py-0 my-0">
              <v-autocomplete
                dense
                outlined
                ref="sucursal"
                v-model="sucursal"
                :items="itemsSucursal"
                item-text="descripcion"
                item-value="id"
                @change="selectClientePorSucursal()"
                label="Sucursal"
                required
              >
              </v-autocomplete>

              <v-spacer></v-spacer>
            </v-col>
            <v-col cols="6" sm="3" md="3" class="py-0 my-0">
              <v-autocomplete
                dense
                outlined
                ref="cliente"
                v-model="cliente"
                :items="itemsCliente"
                item-text="descripcion"
                item-value="codigo_terbol"
                @change="listar()"
                label="Cliente"
                required
              >
                <template v-slot:append-outer>
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon large color="primary" v-bind="attrs" v-on="on">
                        <v-icon dark>fa-solid fa-ellipsis-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="exportarExcel">
                        <v-list-item-icon>
                          <v-icon color="green darken-2">fa-solid fa-file-excel</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar a Excel</v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item @click="confirmarSincronizacion('ciudades')">
                        <v-list-item-icon>
                          <v-icon color="primary">fa-solid fa-city</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Sincronizar Ciudades</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="confirmarSincronizacion('canales')">
                        <v-list-item-icon>
                          <v-icon color="primary">fa-solid fa-network-wired</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Sincronizar Canales</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="confirmarSincronizacion('clientes')">
                        <v-list-item-icon>
                          <v-icon color="primary">fa-solid fa-users</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Sincronizar Clientes</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-autocomplete>

              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="overflow-hidden">
        <v-sheet
          class="overflow-y-auto"
          :max-height="windowHeigth - (isMobile ? 330 : 200)"
        >
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 330 : 200)"
            :headers="headers"
            :items="dtMedioPago"
            :hide-default-header="false"
            :hide-default-footer="true"
            mobile-breakpoint="0"
            sort-by="codigo"
            :search="searchAll"
            class="elevation-1"
            :loading="dtMedioPagoLoad"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template v-slot:[`item.importe`]="{ item }">
              <span class="font-weight-bold"
                >{{ $formatoNumero(item.importe) }}
              </span>
            </template>
            <template v-slot:[`item.saldo`]="{ item }">
              <span class="font-weight-bold"
                >{{ $formatoNumero(item.saldo) }}
              </span>
            </template>

            <template v-slot:[`item.fecha`]="{ item }">
              <span>{{ $formatoFechaSpanish(item.fecha) }} </span>
            </template>

            <template v-slot:no-data>
              <div>No se encontraron registros</div>
            </template>
          </v-data-table>

          <v-skeleton-loader
            v-if="sincronizandoLoad"
            class="pa-2"
            :height="windowHeigth - (isMobile ? 330 : 200)"
            type="table-row-divider@10"
            loading
            elevation="1"
          ></v-skeleton-loader>
          <div v-if="sincronizandoLoad" class="text-center pa-4">
            <v-progress-circular indeterminate color="primary" class="mb-2"></v-progress-circular>
            <div class="text-subtitle-1">Sincronizando datos... Espere por favor</div>
          </div>
        </v-sheet>
      </v-card>

      <v-dialog v-model="dialogConfirmacion" persistent max-width="390">
        <v-card>
          <v-card-title class="text-h6">{{ syncAccionTexto }}</v-card-title>
          <v-card-text>
            ¿Está seguro que desea ejecutar esta sincronización? Esta operación reemplazará los datos existentes.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :disabled="sincronizandoLoad" @click="dialogConfirmacion = false">Cancelar</v-btn>
            <v-btn color="primary" text :loading="sincronizandoLoad" @click="ejecutarSincronizacion">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      //Declaración de variables globales
      user: this.$store.state.usuario.user,
      //Declaración de arrays
      dtMedioPago: [],
      dtMedioPagoLoad: false,

      color: "",

      fechaInicial: "",
      fechaFinal: "",
      errorMessages: "",
      //Declaración de variables de tabla

      headers: [
        {
          text: "Fecha",
          value: "zfecha",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Factura",
          value: "zglosa",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Importe",
          value: "ztmovim",
          align: "right",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Saldo",
          value: "zsaldo",
          align: "right",
          width: "130px",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],

      cliente: "",
      sucursal: "",
      itemsCliente: [],
      itemsSucursal: [],

      searchAll: "",

      //variables de errrores
      valida: 0,
      errorMessages: "",
      modalFechaInicial: false,
      modalFechaFinal: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      error: "",
      //variables de tamaño de pantalla
      isMobile: false,

      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,

      sincronizandoLoad: false,
      dialogConfirmacion: false,
      syncAccion: "",
      syncAccionTexto: "",
    };
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    this.$store.dispatch("actualizarTitulo", "Kardex de Terbol");
    //establecemos la fecha inicial como el primer día del mes actual
    this.fechaInicial = this.$formatoFecha(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    this.fechaFinal = this.$formatoFecha(new Date());

    this.selectSucursal();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    cancelFechaInicial() {
      let me = this;
      me.modalFechaInicial = false;
    },
    cancelFechaFinal() {
      let me = this;
      me.modalFechaFinal = false;
    },
    setFechaInicial() {
      let me = this;
      me.listar();
      me.modalFechaInicial = false;
    },
    setFechaFinal() {
      let me = this;
      me.listar();
      me.modalFechaFinal = false;
    },

    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtMedioPagoLoad = true;
      if (me.cliente == "") {
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un cliente",
          color: "error",
        });
        me.dtMedioPagoLoad = false;
        return;
      }
      //buscamos el valor de codigo_terbol en el cliente seleccionado
      var clienteSeleccionado = me.itemsCliente.find(
        (cliente) => cliente.codigo_terbol == me.cliente
      );

      var canal = clienteSeleccionado.canal;
      var ciudad = clienteSeleccionado.ciudad;

      if (clienteSeleccionado === undefined) {
        me.$store.dispatch("setSnackbar", {
          text: "El cliente seleccionado no es de Terbol",
          color: "error",
        });
        me.dtMedioPagoLoad = false;
        return;
      }

      var url =
        "api/reportes/ListarKardexBonosTerbol/" +
        me.fechaInicial +
        "/" +
        me.fechaFinal +
        "/" +
        me.cliente +
        "/" +
        ciudad +
        "/" +
        canal;

      axios
        .get(url)
        .then(function (response) {
          var lista = response.data.d.data;
          if (lista.length == 0) {
            me.$store.dispatch("setSnackbar", {
              text: "No se encontraron registros",
              color: "error",
            });
            me.dtMedioPagoLoad = false;
            return;
          }
          lista.forEach((item) => {
            item.zsaldo = item.zsaldo.toLocaleString("es-BO", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

            // También formateamos ZTMOVIM si es necesario
            item.ztmovim = item.ztmovim.toLocaleString("es-BO", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          });

          const ultimaFila = lista[lista.length - 1];
          const copiaDeLaUltimaFila = JSON.parse(JSON.stringify(ultimaFila));
          copiaDeLaUltimaFila.zglosa = "Saldo Final";
          copiaDeLaUltimaFila.zfecha = "";
          copiaDeLaUltimaFila.ztmovim = copiaDeLaUltimaFila.zsaldo;
          lista.push(copiaDeLaUltimaFila);

          me.dtMedioPago = lista;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtMedioPagoLoad = false;
        })
        .catch(function (error) {
          me.dtMedioPagoLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    selectClientePorSucursal() {
      let me = this;

      const url = "api/clientes/selectTerbol/" + me.sucursal;

      axios
        .get(url)
        .then(function (response) {
          me.itemsCliente = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    selectSucursal() {
      let me = this;
      me.dtMedioPagoLoad = true;
      axios
        .get("api/clientes/SelectSucursal")
        .then(function (response) {
          me.itemsSucursal = response.data;
          me.dtMedioPagoLoad = false;
        })
        .catch(function (error) {
          me.dtMedioPagoLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    confirmarSincronizacion(accion) {
      const textos = {
        ciudades: "Sincronizar Ciudades",
        canales: "Sincronizar Canales",
        clientes: "Sincronizar Clientes",
      };
      this.syncAccion = accion;
      this.syncAccionTexto = textos[accion];
      this.dialogConfirmacion = true;
    },

    ejecutarSincronizacion() {
      switch (this.syncAccion) {
        case "ciudades":
          this.sincronizarCiudades();
          break;
        case "canales":
          this.sincronizarCanales();
          break;
        case "clientes":
          this.sincronizarClientes();
          break;
      }
    },

    sincronizarCiudades() {
      let me = this;
      me.sincronizandoLoad = true;
      axios
        .get("api/clientes/ObtenerCiudadesTerbol")
        .then(function () {
          me.sincronizandoLoad = false;
          me.dialogConfirmacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Ciudades sincronizadas exitosamente",
            color: "success",
          });
        })
        .catch(function (error) {
          me.sincronizandoLoad = false;
          me.dialogConfirmacion = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    sincronizarCanales() {
      let me = this;
      me.sincronizandoLoad = true;
      axios
        .get("api/clientes/ObtenerCanalesTerbol")
        .then(function () {
          me.sincronizandoLoad = false;
          me.dialogConfirmacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Canales sincronizados exitosamente",
            color: "success",
          });
        })
        .catch(function (error) {
          me.sincronizandoLoad = false;
          me.dialogConfirmacion = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    sincronizarClientes() {
      let me = this;
      me.sincronizandoLoad = true;
      axios
        .get("api/clientes/ObtenerClientesTerbol")
        .then(function () {
          me.sincronizandoLoad = false;
          me.dialogConfirmacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Clientes sincronizados exitosamente",
            color: "success",
          });
        })
        .catch(function (error) {
          me.sincronizandoLoad = false;
          me.dialogConfirmacion = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    exportarExcel() {
      let me = this;
      me.loadingExcel = true;

      if (me.cliente == "") {
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un cliente",
          color: "error",
        });
        me.dtMedioPagoLoad = false;
        return;
      }
      //buscamos el valor de codigo_terbol en el cliente seleccionado
      var clienteSeleccionado = me.itemsCliente.find(
        (cliente) => cliente.codigo_terbol == me.cliente
      );

      var canal = clienteSeleccionado.canal;
      var ciudad = clienteSeleccionado.ciudad;

      if (clienteSeleccionado === undefined) {
        me.$store.dispatch("setSnackbar", {
          text: "El cliente seleccionado no es de Terbol",
          color: "error",
        });
        me.dtMedioPagoLoad = false;
        return;
      }

      var url =
        "api/reportes/GenerarExcelKardexBonosTerbol/" +
        me.fechaInicial +
        "/" +
        me.fechaFinal +
        "/" +
        me.cliente +
        "/" +
        ciudad +
        "/" +
        canal;

      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Reporte Kardex Bonos - " +
            this.$formatoFechaHoras(new Date()) +
            ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.loadingExcel = false;
        me.$store.dispatch("setSnackbar", {
          text: "Excel generado exitosamente",
          color: "success",
        });
      });
    },
  },
};
</script>
